import { Check, TaskView } from '@doist/icons/base';
import { Text } from '@doist/marketist';
import cn from 'clsx';
import { useTranslation } from 'next-i18next';
import css from './AvailableInPlan.module.css';
type Props = {
  isAvailable: boolean;
  className?: string;
};
function AvailableInPlanStatusTag({
  isAvailable = false,
  className,
  ...rest
}: Props) {
  const {
    t
  } = useTranslation('helpcenter');
  const text = isAvailable ? t('article.availableForYourPlan') : t('article.notAvailableForYourPlan');
  return <div className={cn(css.statusTag, !isAvailable ? css.unavailable : null, className)} {...rest} data-sentry-component="AvailableInPlanStatusTag" data-sentry-source-file="AvailableInPlanStatusTag.tsx">
            {isAvailable ? <Check /> : <TaskView />}
            <Text size="body-2xs" data-sentry-element="Text" data-sentry-source-file="AvailableInPlanStatusTag.tsx">{text}</Text>
        </div>;
}
export { AvailableInPlanStatusTag };
export type { Props };